import { useState } from "react";
import {
  Button,
  Card,
  CardActionArea,
  CardContent,
  Grid,
  Typography,
} from "@mui/material";
import { useTranslation } from "react-i18next";
import {
  Add,
  CellTower,
  SettingsInputHdmiOutlined,
  Wifi,
} from "@mui/icons-material";
import NetworkEth from "./NetworkEth";
import NetworkWifi from "./NetworkWifi";
import NetworkBoth from "./NetworkBoth";

type NetworkProps = {
  handleNext: (configuration: any) => void;
  handleBack?: () => void;
};

const Network: React.FC<NetworkProps> = ({ handleNext, handleBack }) => {
  const { t } = useTranslation();

  const [type, setType] = useState<string>("");

  const switchIcon = (type: string) => {
    switch (type) {
      case "wifi":
        return (
          <Grid container direction="column" spacing={2}>
            <Grid item>
              <Wifi style={{ fontSize: "32px" }} />
            </Grid>
            <Grid item>
              <Typography variant="h5">{t("machineNetworkWifi")}</Typography>
            </Grid>
          </Grid>
        );
      case "eth":
        return (
          <Grid container direction="column" spacing={2}>
            <Grid item>
              <SettingsInputHdmiOutlined style={{ fontSize: "32px" }} />
            </Grid>
            <Grid item>
              <Typography variant="h5">{t("ethernet")}</Typography>
            </Grid>
          </Grid>
        );
      case "both":
        return (
          <Grid container direction="column" spacing={2}>
            <Grid
              item
              container
              xs={12}
              spacing={2}
              justifyContent="center"
              alignItems="center"
            >
              <Grid item>
                <Wifi style={{ fontSize: "32px" }} />
              </Grid>
              <Grid item>
                <Add style={{ fontSize: "16px" }} />
              </Grid>
              <Grid item>
                <SettingsInputHdmiOutlined style={{ fontSize: "32px" }} />
              </Grid>
            </Grid>
            <Grid item>
              <Typography variant="h5">{`${t("wifi")} +  ${t(
                "ethernet"
              )}`}</Typography>
            </Grid>
          </Grid>
        );
      default:
        return;
    }
  };

  return (
    <>
      {type === "wifi" && (
        <NetworkWifi handleNext={handleNext} handleBack={() => setType("")} />
      )}
      {type === "eth" && (
        <NetworkEth handleNext={handleNext} handleBack={() => setType("")} />
      )}
      {type === "both" && (
        <NetworkBoth handleNext={handleNext} handleBack={() => setType("")} />
      )}
      {type === "" && (
        <Grid
          container
          spacing={2}
          direction="column"
          alignItems="center"
          justifyContent="center"
          textAlign="center"
        >
          <Grid item>
            <CellTower style={{ fontSize: "64px" }} />
          </Grid>
          <Grid item>
            <Typography variant="h5">{t("network")}</Typography>
          </Grid>
          <Grid item>
            <Typography>{t("selectConnectivityType")}</Typography>
          </Grid>
          <Grid
            container
            item
            spacing={4}
            direction="column"
            alignItems="center"
            justifyContent="center"
          >
            <Grid
              container
              item
              spacing={4}
              alignItems="center"
              justifyContent="center"
            >
              {["wifi", "both", "eth"].map((i: string, index: number) => {
                return (
                  <Grid key={index} item xs={12} md={6} lg={4} xl={3}>
                    <Card variant="outlined">
                      <CardActionArea
                        data-testid={i}
                        onClick={() => setType(i)}
                      >
                        <CardContent
                          style={{ margin: "48px", textAlign: "center" }}
                        >
                          {switchIcon(i)}
                        </CardContent>
                      </CardActionArea>
                    </Card>
                  </Grid>
                );
              })}
            </Grid>
          </Grid>
          <Grid
            container
            item
            xs={8}
            alignItems="center"
            justifyContent="center"
          >
            <Grid
              item
              xs={8}
              container
              spacing={2}
              alignItems="center"
              justifyContent="center"
            >
              {handleBack && (
                <Grid item>
                  <Button
                    data-testid="back"
                    size="large"
                    variant="contained"
                    onClick={() => handleBack()}
                  >
                    {t("back")}
                  </Button>
                </Grid>
              )}
              <Grid item xs></Grid>
              <Grid item visibility="hidden">
                <Button data-testid="next" size="large" variant="contained">
                  {t("back")}
                </Button>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      )}
    </>
  );
};

export default Network;
